import EmptyState from "../components/EmptyState";
import styles from "../Profile.module.css";

const TYPE_ORDER = ["Current", "Permanent"];
const typeRank = (type) => {
  const index = TYPE_ORDER.indexOf(type);
  return index === -1 ? TYPE_ORDER.length : index;
};

const toLines = (a) =>
  [
    [a.addressNum, a.addressLine1].filter(Boolean).join(" "),
    a.addressLine2,
    [a.barangay, a.city || a.municipality].filter(Boolean).join(", "),
    [a.province, a.region, a.postalCode].filter(Boolean).join(", "),
    a.country,
  ].filter(Boolean);

const AddressesSection = ({ addresses }) => {
  if (!addresses.length) return <EmptyState />;

  const sorted = [...addresses].sort(
    (a, b) => typeRank(a.addressType) - typeRank(b.addressType),
  );

  return (
    <div className={styles.cardGrid}>
      {sorted.map((address) => (
        <div key={address.id} className={styles.infoCard}>
          <div className={styles.infoCardHeader}>
            <span className={styles.infoCardTitle}>
              {address.addressType || "Address"}
            </span>
          </div>
          <div className={styles.infoCardLines}>
            {toLines(address).map((line, index) => (
              <div key={index}>{line}</div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AddressesSection;
